<template>
  <div class="version-watermark" aria-label="App version">v{{ version }}</div>
</template>

<script setup lang="ts">
const { public: pub } = useRuntimeConfig();
const version = pub.appVersion || 'dev';
</script>

<style scoped>
.version-watermark {
  position: fixed;
  right: 12px;
  bottom: 8px;
  font-size: 12px;
  opacity: 0.55;
  pointer-events: none;
  z-index: 9999;
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    Arial,
    sans-serif;
}
</style>
